<template>
    <!-- 对话框 -->
    <el-dialog title="添加商家" :visible.sync="show" :modal="false" :before-close="closeDialog" class="dialog">

        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form label-width="80px">

                <el-form-item label="商家名称:" label-width='130px'>
                    <el-input v-model="submit_data.name" style="width: 160px;">
                    </el-input>
                </el-form-item>


                <el-form-item label="手机号:" label-width='130px'>
                    <el-input v-model="submit_data.phone" style="width: 160px;" maxlength="11">
                    </el-input>
                </el-form-item>



            </el-form>

            <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
                <el-button type="primary" @click="addBusiness">保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            'isShow': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

            },

        },
        data() {
            return {

                show: false,



                // 表单提交数据
                submit_data: {
                    name: '',
                    phone: ''
                },



            };
        },
        created() {
            _this = this;

        },
        methods: {

            // 关闭方法
            closeDialog() {

                _this.show = false;

                _this.submit_data = {
                    name: '',
                    phone: ''
                }
            },

            // 提交按钮
            addBusiness() {

                _this.$post(
                    '/activity/addBusiness',
                    _this.submit_data
                )
                    .then(res => {


                        _this.$message.success(res.msg);

                        _this.closeDialog();

                        _this.$emit('onSubmit');


                    }).catch((err) => {

                })

            },

        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
    .dialog{
        width:1000px;
        margin: 5vh auto 0;
    }
</style>
